import { render, staticRenderFns } from "./CompetitionTable.vue?vue&type=template&id=076e2070&scoped=true"
import script from "./CompetitionTable.vue?vue&type=script&lang=js"
export * from "./CompetitionTable.vue?vue&type=script&lang=js"
import style0 from "./CompetitionTable.vue?vue&type=style&index=0&id=076e2070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076e2070",
  null
  
)

export default component.exports